var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$prefixClass.card + '-stroke', 'error-box']},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.error)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }